import React from 'react';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const AiHistoryExtraInfo = ({ info }) => {
  const { t } = useTranslation();

  return (
    <div className={style.extraInfoWrapper}>
      {t('Location')} <span className={style.extraInfo}>{info}</span>
    </div>
  );
};

export default AiHistoryExtraInfo;
